import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://kkblossomschool.org/KKBlossomsWebsite/api.php";

export default function AllImages() {
  const [images, setImages] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const res = await axios.get(`${BASE_URL}?action=getImages`);

      const imageData = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];

      setImages(imageData);
    } catch (err) {
      console.error(err);
      setImages([]);
      setMessage("Failed to load images");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this image?")) return;

    try {
      const res = await axios.get(
        `${BASE_URL}?action=deleteImage&id=${id}`
      );

      if (res.data.status === "deleted") {
        alert("Image deleted");
        fetchImages();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = async (id, category) => {
    try {
      const res = await axios.post(
        `${BASE_URL}?action=updateImage&id=${id}`,
        { category }
      );

      if (res.data.status === "updated") {
        fetchImages();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ padding: "150px 70px" }}>
      <h1>All Images</h1>

      {message && <p>{message}</p>}

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 20,
          marginTop: 30,
        }}
      >
        {images.map((img) => (
          <div
            key={img.id}
            style={{
              width: 170,
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: 10,
            }}
          >
            <img
              src={`https://kkblossomschool.org/KKBlossomsWebsite/uploads/${img.image}`}
              alt=""
              style={{
                width: "100%",
                height: 150,
                objectFit: "cover",
              }}
            />

            <select
              value={img.category || ""}
              onChange={(e) =>
                handleUpdate(img.id, e.target.value)
              }
              style={{
                width: "100%",
                marginTop: 10,
              }}
            >
              <option value="slider">Slider</option>
              <option value="swapper">Swapper</option>
              <option value="activity">Activity</option>
            </select>

            <button
              onClick={() => handleDelete(img.id)}
              style={{
                width: "100%",
                marginTop: 10,
                background: "red",
                color: "#fff",
                border: "none",
                padding: 10,
                cursor: "pointer",
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}